import { RedemptionService } from "../core/redemption-service";


export class ProdRedemptionService extends RedemptionService
{
    
    getBaseUrl = ()=> `https://prod.best-experiences.com/withlogin-universal-redemptions/api`;

    
} 
